import React from "react";
import "../dashboard.css";
import { connect } from "react-redux";
import SearchResult from "./search-results";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import SearchBar from "./search-bar";
import { fetchProducts, searchProduct } from "../../../_actions/search.action";
import NavBar from "../navBar";
import Footer from "../footer";

class SearchDisplay extends React.Component {
  componentDidMount() {
    var searchData=localStorage.getItem("searchData");

    this.props.searchProduct(searchData);
    this.props.fetchProducts(searchData);
  }

  render() {
    const { loading } = this.props;
    return loading ? (
      <div class="row"></div>
    ) : (
      <React.Fragment>
        <NavBar></NavBar>
        <SearchBar/>
        <div className="row">
          <div className="col-sm-8 col-md-6 offset-sm-2 offset-md-3">
            <div class="row">
              <div className="col-10 offset-1" />
                <SearchResult />
              </div>
            </div>

        </div>
        <div className="row nopadding nomargin">
              <div className="col-sm-12 col-md-12 nopadding">
                <Footer/>
              </div>
        </div>

      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.product.loading
});

export default connect(mapStateToProps, { searchProduct, fetchProducts })(
  SearchDisplay
);
